// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3_ei0","file":"styles_file__3atmX"};